import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var ThirtyDayReturnIcon = function ThirtyDayReturnIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5c5.799 0 10.5 4.701 10.5 10.5a10.47 10.47 0 0 1-1.569 5.525l1.366 1.463a.75.75 0 0 1-.442 1.255l-.106.007h-3.5a.75.75 0 0 1-.744-.648L17.5 19.5v-3.75c0-.645.748-.974 1.222-.584l.076.072 1.067 1.143A9 9 0 1 0 12 21a.75.75 0 1 1 0 1.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5zm-1.25 7.25a.75.75 0 0 1 .743.648l.007.102v5a.75.75 0 0 1-.648.743l-.102.007h-2.5a.75.75 0 0 1-.102-1.493l.102-.007H10v-1H8.25a.75.75 0 0 1-.743-.648L7.5 12a.75.75 0 0 1 .648-.743l.102-.007H10v-1H8.25a.75.75 0 0 1-.743-.648L7.5 9.5a.75.75 0 0 1 .648-.743l.102-.007h2.5zm5 0a.75.75 0 0 1 .743.648l.007.102v5a.75.75 0 0 1-.648.743l-.102.007h-2.5a.75.75 0 0 1-.743-.648L12.5 14.5v-5a.75.75 0 0 1 .75-.75h2.5zm-.75 1.5h-1v3.5h1v-3.5z"
  }));
};

ThirtyDayReturnIcon.displayName = 'ThirtyDayReturnIcon';
export default ThirtyDayReturnIcon;